import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Configuration from "../configuration";
var token = localStorage.getItem("x-access-token");




export const verifEntete = createAsyncThunk("pct/verifEntete", async (action) => {
    const response = await fetch(Configuration.BACK_BASEURL + "pct/verifEntete", {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': token
        },
        body: JSON.stringify(action)
    });
    const pct = await response.json();
    return pct;
});

//upload BL file
export const saveFile = createAsyncThunk("pct/saveFile", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "pct/saveFile", {
    method: 'POST',
    headers: {
      'Accept': 'application/*',
      'x-access-token':token,
    },
    body:action
  });
  const pctjour = await response.json();
  return pctjour;
});


export const AddedExcel = createAsyncThunk("pct/enteteAddedExcel", async (action) => {
    const response = await fetch(Configuration.BACK_BASEURL + "pct/enteteAddedExcel", {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': token
        },
        body: JSON.stringify(action)
    });
    const pct = await response.json();
    return pct;
});


export const fetchPCT = createAsyncThunk("pct/allPCT", async (action) => {
    const response = await fetch(Configuration.BACK_BASEURL + "pct/allPCT", {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': token
        },
        body: JSON.stringify(action)
    });
    const pct = await response.json();
    return pct;
});


export const fetchPCTForExportExcel = createAsyncThunk("pct/fetchPCTForExportExcel", async (action) => {
    const response = await fetch(Configuration.BACK_BASEURL + "pct/fetchPCTForExportExcel", {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': token
        },
        body: JSON.stringify(action)
    });
    const fetchPCTForExportExcel = await response.json();
    return fetchPCTForExportExcel;
});


export const PCTDeleted = createAsyncThunk("pct/delete", async (action) => {
    const response = await fetch(Configuration.BACK_BASEURL + "pct/delete/" + action.id, {
        method: 'DELETE',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': token
        },
    });
    const pct = await response.json();
    return pct;
});



export const checkGrossiste = createAsyncThunk("pct/checkGrossiste", async (action) => {

    const response = await fetch(Configuration.BACK_BASEURL + "pct/checkGrossiste", {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': token
        },
        body: JSON.stringify(action)
    });
    const pct = await response.json();
    return pct;
});




const PCTReduce = createSlice({
    name: "pct",
    initialState: {
        entities: [],
        loading: false,
    },
    reducers: {

    },
    extraReducers: {
    },
});


export default PCTReduce.reducer;